// src/components/Hero.js
import React from "react";
import { useDynamicCSS } from "../hooks/DynamicCSSLoader";
import AnimatedHeroBackground from "./AnimatedHeroBackground";
import TypingAnimation from "./TypingAnimation";
import FeaturesPanel from "./FeaturesPanel";
import "./HeroLayout.css";

const Hero = () => {
  useDynamicCSS("hero");

  return (
    <AnimatedHeroBackground>
      <div className="hero-wrapper-with-stats">
        <div className="hero-content-main">
          <TypingAnimation />
        </div>

        <div className="hero-stats-container">
          <FeaturesPanel />
        </div>
      </div>
    </AnimatedHeroBackground>
  );
};

export default Hero;
